/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


// (function() {
//   // Add custom code below this line


  




//   // ^^ Keep your scripts inside this IIFE function call to 
//   // avoid leaking your variables into the global scope.
// })();


jQuery(document).ready(function(){
  jQuery(".accordion-header").click(function(){
    let item = $(this).next(".accordion-content");

    // Close all other items
    $(".accordion-content").not(item).slideUp();
    $(".accordion-header").not(this).removeClass("active");

    // Toggle this one
    $(this).toggleClass("active");
    item.stop(true, true).slideToggle();

  });
});


document.addEventListener("DOMContentLoaded", function () {
  const wrapper = document.querySelector(".video-wrapper");
  const video = wrapper.querySelector(".reels-video-fullpopup");
  const playPauseBtn = document.getElementById("playPauseBtn");

  if (!video) return;

  let firstClick = true;

  function setPlayIcon() {
    playPauseBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
        <rect width="65" height="65" rx="32.5" fill="white"/>
        <path d="M27.5 22.5 C25.6 21.3 24 22.3 24 24.5 V41 C24 43.3 25.6 44.2 27.5 43.1 L41.9 34.8 C43.8 33.7 43.8 31.9 41.9 30.8 L27.5 22.5 Z" fill="#A9838B"/>
      </svg>`;
  }

  function setPauseIcon() {
    playPauseBtn.innerHTML = `
      <svg xmlns="http://www.w3.org/2000/svg" width="65" height="65" viewBox="0 0 65 65" fill="none">
        <rect width="65" height="65" rx="32.5" fill="white"/>
        <rect x="24" y="22" width="5" height="21" fill="#A9838B"/>
        <rect x="36" y="22" width="5" height="21" fill="#A9838B"/>
      </svg>`;
  }


  playPauseBtn.addEventListener("click", function () {
    if (video.paused) {
      video.play();
    } else {
      video.pause();
    }

    if (firstClick) {
      playPauseBtn.style.opacity = "0"; // hide after first click
      firstClick = false;
    }
  });

  // when video plays → show pause icon, hide button
  video.addEventListener("play", function () {
    setPauseIcon();
    playPauseBtn.style.opacity = "0";
  });

  // when video pauses → show play icon always
  video.addEventListener("pause", function () {
    setPlayIcon();
    playPauseBtn.style.opacity = "1";
  });

  // hover effect (only while playing)
  wrapper.addEventListener("mouseenter", function () {
    if (!video.paused) {
      playPauseBtn.style.opacity = "1";
    }
  });

  wrapper.addEventListener("mouseleave", function () {
    if (!video.paused) {
      playPauseBtn.style.opacity = "0";
    }
  });
});

document.addEventListener('click', function(e) {
  if (e.target.closest('.product-item .btn-wrapper .icon-cart-btn')) {
    let productItem = e.target.closest('.product-item');
    let quickAddBtn = productItem.querySelector('.quick-add__button');
    if (quickAddBtn) {
      quickAddBtn.click();
    }
  }
});


document.addEventListener("click", function(e) {
  if (e.target.closest(".js-fbt-add-to-cart")) {
    const button = e.target.closest(".js-fbt-add-to-cart");
    const variantId = button.getAttribute("data-variant-id");

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        id: variantId,
        quantity: 1
      }),
    })
    .then(res => res.json())
    .then(data => {
      console.log("Added to cart:", data);
      // 🔄 Refresh the page after adding to cart
      window.location.reload();
    })
    .catch(err => console.error("Error adding to cart:", err));
  }
});


// document.querySelectorAll('.read-more').forEach(button => {
//   button.addEventListener('click', function () {
//     const parent = this.closest('.pro-desc');
//     parent.classList.toggle('active');

//     this.textContent = this.textContent === 'læs mere' ? 'læs mindre' : 'læs mere';
//   });
// });


// jQuery(document).ready(function () {
//   jQuery(".product-faq-sec .faq-item .faq-question").on("click", function () {
//     let $item = jQuery(this).closest(".faq-item");
//     let $answer = $item.find(".faq-answer");
//     let $toggle = $item.find(".faq-toggle");

//     if ($item.hasClass("active")) {
//       // Close
//       $answer.slideUp(300);
//       $item.removeClass("active");
//       //$toggle.text("+");
//       $toggle.html('<img src="https://cdn.shopify.com/s/files/1/0526/9775/9936/files/Group_1413375814.svg?v=1761943212">');
//     } else {
//       // Close others
//       jQuery(".product-faq-sec .faq-item.active .faq-answer").slideUp(300);
//       jQuery(".product-faq-sec .faq-item").removeClass("active");
//       jQuery(".product-faq-sec .faq-item .faq-toggle").html('<img src="https://cdn.shopify.com/s/files/1/0526/9775/9936/files/Group_1413375814.svg?v=1761943212">');

//       // Open clicked one
//       $answer.slideDown(300);
//       $item.addClass("active");
//       //$toggle.text("–"); // change to minus
//       $toggle.html('<img src="https://cdn.shopify.com/s/files/1/0526/9775/9936/files/Vector_79.svg?v=1761943214">');
//     }
//   });
// });

// document.addEventListener("DOMContentLoaded", function () {
//   const faqQuestions = document.querySelectorAll(".product-faq-sec .faq-item .faq-question");

//   const closedIcon = '<img src="https://cdn.shopify.com/s/files/1/0526/9775/9936/files/Group_1413375814.svg?v=1761943212">';
//   const openIcon = '<img src="https://cdn.shopify.com/s/files/1/0526/9775/9936/files/Vector_79.svg?v=1761943214">';

//   faqQuestions.forEach(function (question) {
//     question.addEventListener("click", function () {
//       const item = this.closest(".faq-item");
//       const answer = item.querySelector(".faq-answer");
//       const toggle = item.querySelector(".faq-toggle");
//       const isActive = item.classList.contains("active");

//       // Close all other items first
//       document.querySelectorAll(".product-faq-sec .faq-item").forEach(function (otherItem) {
//         if (otherItem !== item && otherItem.classList.contains("active")) {
//           const otherAnswer = otherItem.querySelector(".faq-answer");
//           const otherToggle = otherItem.querySelector(".faq-toggle");
          
//           otherAnswer.style.maxHeight = null;
//           otherItem.classList.remove("active");
//           otherToggle.innerHTML = closedIcon;
//         }
//       });

//       // Toggle clicked item
//       if (isActive) {
//         answer.style.maxHeight = null;
//         item.classList.remove("active");
//         toggle.innerHTML = closedIcon;
//       } else {
//         answer.style.maxHeight = answer.scrollHeight + "px";
//         item.classList.add("active");
//         toggle.innerHTML = openIcon;
//       }
//     });
//   });
// });


jQuery(document).ready(function ($) {
  function initKitToggle() {
    if ($(window).width() < 768) {
      // Hide items after the 5th on load
      $(".kit-list ul .kit-item:nth-child(n+6)").hide();

      $(".complete-kit-sec li.read-more-btn a").off("click").on("click", function (e) {
        e.preventDefault();

        let $kitList = $(".kit-list ul");
        let $hiddenItems = $kitList.find(".kit-item:nth-child(n+6)");
        let $btn = $(this);

        if ($kitList.hasClass("active")) {
          // Collapse → show only first 5
          $hiddenItems.slideUp(300);
          $kitList.removeClass("active");
          $btn.text("Read More");
        } else {
          // Expand → show all items
          $hiddenItems.slideDown(300);
          $kitList.addClass("active");
          $btn.text("Show Less");
        }
      });
    } else {
      // Reset for desktop
      $(".kit-list ul .kit-item").show();
      $(".kit-list ul").removeClass("active");
      $(".complete-kit-sec li.read-more-btn a").text("Read More");
    }
  }

  // Run on load
  initKitToggle();

  // Run on resize
  $(window).on("resize", function () {
    initKitToggle();
  });
});




document.querySelector(".search-bar-btn").addEventListener("click", function() {
  document.querySelector(".search-bar-hidden header-search-popdown details summary").click();
});


jQuery(document).ready(function ($) {
  $(".tabs-section .tab-content a.read-more").on("click", function (e) {
    e.preventDefault();
    $(this).closest(".tab-content").toggleClass("read-content");
  });
});


// Bonus Tips Js

document.querySelectorAll('.bonus-tips').forEach(box => {
  const video = box.querySelector('video');
  const playBtn = box.querySelector('.play-btn');

  if (!video || !playBtn) return;

  // Function to pause all other videos
  const pauseOtherVideos = () => {
    document.querySelectorAll('.bonus-tips').forEach(otherBox => {
      const otherVideo = otherBox.querySelector('video');
      const otherBtn = otherBox.querySelector('.play-btn');
      if (otherVideo && otherBtn && otherVideo !== video) {
        otherVideo.pause();
        otherBtn.style.display = 'block';
      }
    });
  };

  // Toggle video
  const toggleVideo = () => {
    if (video.paused) {
      pauseOtherVideos();
      video.play().catch(() => {}); // ignore AbortError
      playBtn.style.display = 'none';
    } else {
      video.pause();
      playBtn.style.display = 'block';
    }
  };

  // Event listeners
  playBtn.addEventListener('click', (e) => {
    e.stopPropagation();
    toggleVideo();
  });

  video.addEventListener('click', toggleVideo);

  video.addEventListener('ended', () => {
    playBtn.style.display = 'block';
  });
});

// Video Guide Sec Js

document.querySelectorAll('.video-box').forEach(box => {
  const video = box.querySelector('video');
  const playBtn = box.querySelector('.play-btn');

  // Play video when the box or play button is clicked
  box.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      playBtn.style.display = 'none'; // hide play button when playing
    } else {
      video.pause();
      playBtn.style.display = 'block'; // show play button when paused
    }
  });

  // Optional: pause video when it ends
  video.addEventListener('ended', () => {
    playBtn.style.display = 'block';
  });
});

/*
document.addEventListener('DOMContentLoaded', function () {
  // Initialize Splide and keep reference
  const guideSplide = new Splide('.guide-splide', {
    //type   : 'loop',
    perPage: 3,
    gap    : '1rem',
    arrows : false, // disable default arrows
    pagination: false,
    breakpoints: {
      1024: { perPage: 2 },
      768 : { perPage: 1, gap: '11px' }
    }
  });

  guideSplide.mount();

  // Connect custom arrows
  document.querySelector('.guide-prev').addEventListener('click', () => {
    guideSplide.go('<');
  });
  document.querySelector('.guide-next').addEventListener('click', () => {
    guideSplide.go('>');
  });
});
*/
document.addEventListener('DOMContentLoaded', function () {
  // Select all sliders on the page
  const sliders = document.querySelectorAll('.guide-splide');

  sliders.forEach(function (sliderEl) {
    // Initialize each Splide individually
    const splide = new Splide(sliderEl, {
      perPage: 3,
      gap: '1rem',
      arrows: false,
      pagination: false,
      breakpoints: {
        1024: { perPage: 2 },
        768: { perPage: 1, gap: '11px' }
      }
    });

    splide.mount();

    // Scope next/prev buttons to this slider’s parent section
    const section = sliderEl.closest('section');
    const prevBtn = section?.querySelector('.guide-prev');
    const nextBtn = section?.querySelector('.guide-next');

    if (prevBtn) prevBtn.addEventListener('click', () => splide.go('<'));
    if (nextBtn) nextBtn.addEventListener('click', () => splide.go('>'));
  });
});




document.querySelectorAll('.bonus-tips .read-more').forEach(btn => {
  btn.addEventListener('click', function () {
    const parent = this.closest('.bonus-tips');
    const desc = parent.querySelector('.desc');

    this.classList.toggle('active');
    desc.classList.toggle('expanded'); // add/remove class on .desc

    if (this.classList.contains('active')) {
      this.textContent = 'læs mindre';
    } else {
      this.textContent = 'læs mere';
    }
  });
});


